var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m4 20-.699-.042A.7.7 0 0 0 4 20.7zm16 0v.7a.7.7 0 0 0 .699-.742zm-15.301.042c.216-3.623 3.23-6.496 6.916-6.496v-1.4c-4.43 0-8.053 3.452-8.314 7.812zm6.916-6.496h.77v-1.4h-.77zm.77 0c3.687 0 6.7 2.873 6.916 6.496l1.398-.084c-.261-4.36-3.884-7.812-8.314-7.812zM20 19.3H4v1.4h16zM14.306 7c0 1.27-1.032 2.3-2.306 2.3v1.4A3.703 3.703 0 0 0 15.706 7zM12 9.3A2.303 2.303 0 0 1 9.695 7h-1.4c0 2.045 1.66 3.7 3.705 3.7zM9.695 7c0-1.269 1.03-2.3 2.305-2.3V3.3A3.703 3.703 0 0 0 8.295 7zM12 4.7A2.303 2.303 0 0 1 14.306 7h1.4c0-2.044-1.66-3.7-3.706-3.7z"
  })));
};
export default SvgUser;